import { useState } from 'react'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function Tabs({ tabs, containerStyle, onChangeTab }) {
    const [selectedTab, setSelectedTab] = useState(tabs[0].name)

    function changeTab(tab) {
        setSelectedTab(tab)
        onChangeTab(tab)
    }

    return (
        <ContainerTab style={containerStyle}>
            <StyledTab>
                {Object.values(tabs).map((tab) => (
                    <TabItem
                        key={tab.name}
                        onClick={() => changeTab(tab.name)}
                        active={selectedTab === tab.name}
                        disabled={tab.disabled}
                    >
                        {tab.label}
                    </TabItem>
                ))}
            </StyledTab>
        </ContainerTab>
    );
}

const ContainerTab = styled.div`
    display: flex;
    justify-content: flex-start;
`

const StyledTab = styled(Row)`
    width: 100%;
    display: flex;
    align-items: center;
    overflow-x: auto;

    border-bottom: 1px solid ${colors.primaryDashboard};
`;

const TabItem = styled.div`
    cursor: pointer;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: auto;
    padding: 0 14px;
    text-align: center;
    color: ${colors.nightDark};
    font-weight: bold;
    transition: all ease-in-out 0.25s;


    @media screen and (min-width: ${breakpoints.lg}) {
        ${({ disabled }) => !disabled && `
            &:hover {
                color: ${colors.secondaryPurple};
            }
        `}
    }
   
    ${({ disabled }) => disabled && `
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
    `}

    ${({ active }) => active && `
        color: ${colors.secondaryPurple};
        border-bottom: 2px solid ${colors.secondaryPurple};
    `}
    
`;